import { render } from "./CreateGroup.vue?vue&type=template&id=a88e49cc&scoped=true"
import script from "./CreateGroup.vue?vue&type=script&lang=js"
export * from "./CreateGroup.vue?vue&type=script&lang=js"

import "./CreateGroup.vue?vue&type=style&index=0&id=a88e49cc&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a88e49cc"]])

export default __exports__